import { Component } from 'shimmer'

import { ShaderMaterial, Mesh, DoubleSide, LessEqualDepth } from 'three'
import glsl from 'glslify'

export class Fader extends Component {
  constructor (geometry) {
    super({name: 'ObjectOfTheDeath'})

    this.geometry = geometry

    this.uniforms = {
      uThreshold: { type: 'f', value: 0 }
    }

    this.material = new ShaderMaterial({
      vertexShader: glsl(require('../shaders/fade.vert').default),
      fragmentShader: glsl(require('../shaders/fade.frag').default),
      transparent: true,
      depthTest: true,
      // depthWrite: false,
      depthFunc: LessEqualDepth,
      uniforms: this.uniforms
    })
    this.material.transparent = true
    this.material.side = DoubleSide

    this.mesh = new Mesh(this.geometry, this.material) 

    this.add(this.mesh)
  }

  set threshold (value) {
    this.uniforms.uThreshold.value = 1 - value
  }

  get threshold () {
    return 1 - this.uniforms.uThreshold.value 
  }
}